export class HostRoute
{
    destination: string;
    nextHop: string;
}
